<template>
  <Dialog
    :visible="visible"
    header="Add Site"
    :modal="true"
    :style="{ width: '640px' }"
    class="p-fluid"
    @update:visible="$emit('close')"
  >
    <p class="sp-sub" style="margin-top: 0;">
      A Site is the physical place: one address. Blocks, phases or buildings on it are Projects.
    </p>

    <div class="p-formgrid p-grid">
      <div class="p-field p-col-12">
        <label for="spSiteName">Site name *</label>
        <InputText id="spSiteName" v-model.trim="site.name" style="text-transform: uppercase;" placeholder="e.g. TRAFFORD WATERS" />
        <small v-if="submitted && !site.name" class="p-invalid">Site name is required.</small>
      </div>
    </div>

    <div class="p-formgrid p-grid">
      <div class="p-field p-col-5">
        <label for="spPostCode">Postcode *</label>
        <div class="p-inputgroup">
          <InputText id="spPostCode" v-model.trim="site.postCode" style="text-transform: uppercase;" placeholder="M41 7GG" />
          <Button label="Find address" class="p-button-secondary" disabled title="Postcode look-up: proposed, not in the mock-up" />
        </div>
        <small v-if="site.postCode && !postCodeValid" class="sp-muted">Not a full UK postcode. A partial one (e.g. M11) can be saved and completed later.</small>
        <small v-if="submitted && !site.postCode" class="p-invalid">Postcode is required.</small>
      </div>
      <div class="p-field p-col-7">
        <label for="spTown">Town/City *</label>
        <InputText id="spTown" v-model.trim="site.town" placeholder="From the Cities/Towns list" />
        <small v-if="submitted && !site.town" class="p-invalid">Town/City is required.</small>
      </div>
    </div>

    <div class="p-formgrid p-grid">
      <div class="p-field p-col-6">
        <label for="spAddr1">Street *</label>
        <InputText id="spAddr1" v-model.trim="site.address1" />
        <small v-if="submitted && !site.address1" class="p-invalid">Street is required.</small>
      </div>
      <div class="p-field p-col-6">
        <label for="spAddr2">Sub Area</label>
        <InputText id="spAddr2" v-model.trim="site.address2" />
      </div>
    </div>

    <div class="p-formgrid p-grid">
      <div class="p-field p-col-6">
        <label for="spCounty">County</label>
        <InputText id="spCounty" v-model.trim="site.county" />
      </div>
      <div class="p-field p-col-6">
        <label for="spCountry">Country</label>
        <InputText id="spCountry" value="United Kingdom" disabled />
      </div>
    </div>

    <div v-if="matches.length" class="sp-note warn" style="display: block;">
      <div><i class="pi pi-exclamation-triangle"></i> <strong>Possible existing sites</strong>: please check before adding a new one.</div>
      <table class="sp-table" style="margin-top: 6px; background: #fff;">
        <tr v-for="m in matches" :key="m.site.id">
          <td><strong>{{ m.site.name }}</strong><br /><span class="sp-muted">{{ [m.site.address1, m.site.town, m.site.postCode].filter(Boolean).join(', ') }}</span></td>
          <td class="sp-muted">{{ m.reasons.join(', ') }}<br />{{ projectCount(m.site.id) }} project(s)</td>
          <td style="width: 110px;"><Button label="Use this site" class="p-button-sm p-button-outlined" @click="$emit('picked', m.site)" /></td>
        </tr>
      </table>
    </div>

    <template #footer>
      <Button label="Cancel" icon="pi pi-times" class="p-button-danger" style="width: auto;" @click="$emit('close')" />
      <Button label="Save site" icon="pi pi-check" class="p-button-success" style="width: auto;" @click="save" />
    </template>
  </Dialog>
</template>

<script>
import { sites, possibleDuplicateSites, projectsOfSite } from './mockData'

// Full UK postcode, e.g. M41 7GG / SW1A 1AA
const UK_POSTCODE = /^[A-Z]{1,2}[0-9][A-Z0-9]? ?[0-9][A-Z]{2}$/i

export default {
  name: 'SiteForm',
  props: { visible: Boolean, initialName: { type: String, default: '' } },
  data() {
    return {
      site: { name: this.initialName, postCode: '', town: '', address1: '', address2: '', county: '' },
      submitted: false
    }
  },
  computed: {
    postCodeValid() { return UK_POSTCODE.test(this.site.postCode || '') },
    matches() { return possibleDuplicateSites(this.site.name, this.site.postCode) }
  },
  methods: {
    projectCount(siteId) { return projectsOfSite(siteId).length },
    save() {
      this.submitted = true
      const s = this.site
      if (!s.name || !s.postCode || !s.town || !s.address1) return
      // Mock only: kept in memory until the page is reloaded, so the flow can be walked through.
      const created = { ...s, name: s.name.toUpperCase(), postCode: s.postCode.toUpperCase(), id: Date.now(), created: new Date().toLocaleDateString('en-GB'), createdBy: 'You' }
      sites.push(created)
      this.$emit('picked', created)
    }
  }
}
</script>

<style scoped>
@import './sitesProjects.css';
</style>
